import { useSelector } from "react-redux";
import '../registerSyncfusion';
import { Internationalization } from '@syncfusion/ej2-base';

export function useInstance() {

    const { lang } = useSelector(state => state.translate);
    const instance = new Internationalization(lang);

    return instance
}

export default useInstance